<template>
  <v-row>
    <v-col md="5" class="pb-0 hidden-sm-and-down">
      <v-img class="sticky-image" height="100vh" src="../assets/register-dog.png" />
    </v-col>
    <v-col class="register pb-0" md="7" sm="12">
      <h1 class="register-title">Oops!</h1>
      <p>You do not have the sufficient permissions to access this page. Click <router-link to="/">here</router-link> to go back to the home screen.</p>
    </v-col>
  </v-row>
</template>

<script lang="ts">
import Vue from 'vue';
export default Vue.extend({
  name: 'InsufficientPermissions',
});
</script>
